<template>
  <section class="details container--Medium defaultSectionPaddings">
    <h2 v-text="data.title" />

    <div v-if="data.feature_details?.length" class="details__List">
      <div v-for="item in data.feature_details" class="details__ListItem">
        <div>
          <h3 v-text="item.title" />
          <p v-if="item.lead" v-text="item.lead" />
        </div>

        <div>
          <Flare v-if="item.image" :srcset="item.image" size="both" width="530" height="400" crop="fill" gravity="faces" :alt="item.image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_details.scss');
</style>